import Carousel from 'react-bootstrap/Carousel'
import './slider.css'
import { Button, Container } from 'react-bootstrap'
import React, { useState, useEffect, useCallback } from 'react'
import { faStar } from '@fortawesome/free-solid-svg-icons/faStar'
import { faStarHalfAlt } from '@fortawesome/free-solid-svg-icons/faStarHalfAlt'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { fetchGoogleReviews } from '../../utils/googleReviews'

function NewsSlide() {
  const [reviews, setReviews] = useState([])
  const [rating, setRating] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [lastUpdated, setLastUpdated] = useState(null)

  const placeId = process.env.REACT_APP_GOOGLE_PLACE_ID || 'ChIJoR2SeG5dtokRlWJo3euCGh4'
  const reviewUrl = `https://search.google.com/local/writereview?placeid=${placeId}`

  const loadReviews = useCallback(async () => {
    setLoading(true)
    setError('')
    try {
      const data = await fetchGoogleReviews()
      setReviews(data.reviews)
      setRating(data.rating)
      setLastUpdated(new Date())

      if (!data.reviews.length) {
        setError('No reviews returned for this location yet.')
      }
    } catch (err) {
      setError('Unable to load reviews right now.')
      console.error('Error fetching Google reviews:', err)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    loadReviews()
    const interval = setInterval(loadReviews, 180000)
    return () => clearInterval(interval)
  }, [loadReviews])

  const ReviewsLink = () => {
    window.open(reviewUrl, '_blank', 'noopener,noreferrer')
  }

  const renderStars = (value) => {
    const safe = Number(value) || 0
    const full = Math.floor(safe)
    const hasHalf = safe - full >= 0.5
    const stars = []
    for (let i = 0; i < full; i += 1) {
      stars.push(<FontAwesomeIcon key={`full-${i}`} icon={faStar} className="rating-icons" />)
    }
    if (hasHalf) stars.push(<FontAwesomeIcon key="half" icon={faStarHalfAlt} className="rating-icons" />)
    return stars
  }

  return (
    <Container className="reviews-modern mt-3 mb-4">
      <div className="reviews-modern-head">
        <div>
          <p className="reviews-modern-label">Google Reviews</p>
          <div className="reviews-modern-rating">
            <span className="reviews-rating-number">{rating || '--'}</span>
            <div className="rating">{renderStars(rating)}</div>
          </div>
        </div>
        <div className="reviews-modern-tools">
          <Button className="reviews-refresh-btn" variant="" onClick={loadReviews} disabled={loading}>
            {loading ? 'Refreshing...' : 'Refresh Reviews'}
          </Button>
          {lastUpdated && (
            <span className="reviews-last-updated">Updated {lastUpdated.toLocaleTimeString()}</span>
          )}
        </div>
      </div>

      {error && <p className="reviews-error">{error}</p>}

      <div className="row-fluid">
        {reviews.length > 0 ? (
          <Carousel data-bs-theme="dark" className="mb-3 reviews-carousel">
            {reviews.map((item, index) => (
              <Carousel.Item key={`${item.author_name}-${index}`}>
                <div className="review-card">
                  <img
                    className="d-block mx-auto imgstyle"
                    src={item.profile_photo_url}
                    alt={item.author_name || 'Reviewer profile'}
                  />
                  <div className="review-card-body">
                    <h5>{item.author_name}</h5>
                    <p className="review-text">{item.text}</p>
                    <span className="review-meta">
                      {item.relative_time_description} • Rating: {item.rating}
                    </span>
                  </div>
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
        ) : !loading && !error && (
          <p className="reviews-empty">Reviews will appear here once loaded.</p>
        )}

        <Button className="btn-rita reviews-add-btn" variant="" onClick={ReviewsLink}>
          Add New Review
        </Button>
      </div>
    </Container>
  )
}

export default NewsSlide
